import { render } from "./DashboardLegend.vue?vue&type=template&id=144f8c31&scoped=true"
import script from "./DashboardLegend.vue?vue&type=script&lang=js"
export * from "./DashboardLegend.vue?vue&type=script&lang=js"

import "./DashboardLegend.vue?vue&type=style&index=0&id=144f8c31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144f8c31"]])

export default __exports__